const readFileAsDataUrl = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error("Datei konnte nicht gelesen werden."));
    reader.readAsDataURL(file);
  });

const loadImage = (dataUrl: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Bild konnte nicht geladen werden."));
    img.src = dataUrl;
  });

/**
 * Convert an uploaded image to a reasonably sized data URL (maxDimension px).
 * Keeps aspect ratio and uses a light compression to keep payloads small.
 */
export const resizeImageToDataUrl = async (file: File, maxDimension = 640): Promise<string> => {
  const rawDataUrl = await readFileAsDataUrl(file);
  const img = await loadImage(rawDataUrl);
  const largestSide = Math.max(img.width, img.height);
  const scale = largestSide > maxDimension ? maxDimension / largestSide : 1;

  const width = Math.max(1, Math.round(img.width * scale));
  const height = Math.max(1, Math.round(img.height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("Canvas nicht verfügbar – Avatar konnte nicht verarbeitet werden.");
  }

  ctx.drawImage(img, 0, 0, width, height);

  const mimeType = file.type && file.type.startsWith("image/") ? file.type : "image/jpeg";
  const quality = mimeType === "image/png" ? 0.92 : 0.85;

  return canvas.toDataURL(mimeType, quality);
};
